/** Single source of truth for supported blog canvas decor kinds. */ const $5b8e7fae80eb3a8a$export$e45e8ebdaeaf03e9 = [
    "local-inference",
    "asking",
    "boids",
    "diff"
];
const $5b8e7fae80eb3a8a$export$14559167883cfcce = new Set($5b8e7fae80eb3a8a$export$e45e8ebdaeaf03e9);


/** Deterministic PRNG — same algorithm as scripts/blog/generate.mjs */ function $7e612384a04d987e$export$7f4f77f59a323cea(seed) {
    let h1 = 1779033703;
    let h2 = 3144134277;
    let h3 = 1013904242;
    let h4 = 2773480762;
    for(let i = 0; i < seed.length; i++){
        const k = seed.charCodeAt(i);
        h1 = h2 ^ Math.imul(h1 ^ k, 597399067);
        h2 = h3 ^ Math.imul(h2 ^ k, 2869860233);
        h3 = h4 ^ Math.imul(h3 ^ k, 951274213);
        h4 = h1 ^ Math.imul(h4 ^ k, 2716044179);
    }
    h1 = Math.imul(h3 ^ h1 >>> 18, 597399067);
    h2 = Math.imul(h4 ^ h2 >>> 22, 2869860233);
    h3 = Math.imul(h1 ^ h3 >>> 17, 951274213);
    h4 = Math.imul(h2 ^ h4 >>> 19, 2716044179);
    let a = h1 >>> 0;
    let b = h2 >>> 0;
    let c = h3 >>> 0;
    let d = h4 >>> 0;
    return function() {
        a >>>= 0;
        b >>>= 0;
        c >>>= 0;
        d >>>= 0;
        const t = a + b | 0;
        a = b ^ b >>> 9;
        b = c + (c << 3) | 0;
        c = c << 21 | c >>> 11;
        d = d + 1 | 0;
        const nextT = t + d | 0;
        c = c + nextT | 0;
        return (nextT >>> 0) / 4294967296;
    };
}


const $f7b52c0eefeb7e27$var$DX = [
    1,
    0,
    -1,
    0
];
const $f7b52c0eefeb7e27$var$DY = [
    0,
    1,
    0,
    -1
];
const $f7b52c0eefeb7e27$var$CELL = 14;
const $f7b52c0eefeb7e27$var$STEP_MS = 50;
const $f7b52c0eefeb7e27$var$FADE_MS = 2500;
function $f7b52c0eefeb7e27$var$readColor(root, varName) {
    return getComputedStyle(root).getPropertyValue(`--fx-${varName}`).trim();
}
function $f7b52c0eefeb7e27$var$measure(box) {
    const rect = box.getBoundingClientRect();
    const mobile = rect.width < 768;
    const dpr = Math.min(mobile ? 1.25 : 2, window.devicePixelRatio || 1);
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const w = Math.max(1, Math.round(rect.width));
    const h = Math.max(1, Math.round(rect.height));
    const title = box.querySelector(".blog-title");
    const titleBot = title ? title.getBoundingClientRect().bottom - rect.top : mobile ? 100 : 130;
    const zoneTop = Math.max(10, titleBot - 60);
    const zoneBot = titleBot + (mobile ? 100 : 160);
    const drawH = Math.min(zoneBot + 30, h);
    const cols = Math.floor(w / $f7b52c0eefeb7e27$var$CELL);
    const rows = Math.floor((zoneBot - zoneTop) / $f7b52c0eefeb7e27$var$CELL);
    const ox = (w - cols * $f7b52c0eefeb7e27$var$CELL) / 2;
    return {
        width: w,
        height: h,
        dpr: dpr,
        mobile: mobile,
        reduced: reduced,
        zoneTop: zoneTop,
        zoneBot: zoneBot,
        drawH: drawH,
        cols: cols,
        rows: rows,
        cell: $f7b52c0eefeb7e27$var$CELL,
        ox: ox,
        oy: zoneTop
    };
}
function $f7b52c0eefeb7e27$var$buildTurtles(rand, m, n) {
    const turtles = [];
    for(let i = 0; i < n; i++)turtles.push({
        col: Math.floor(rand() * m.cols),
        row: Math.floor(rand() * m.rows),
        dir: Math.floor(rand() * 4),
        phase: rand() * Math.PI * 2
    });
    return turtles;
}
function $f7b52c0eefeb7e27$var$stepTurtle(t, m, rand) {
    const x1 = m.ox + t.col * m.cell + m.cell / 2;
    const y1 = m.oy + t.row * m.cell + m.cell / 2;
    const r = rand();
    let dir = t.dir;
    if (r < 0.25) dir = (dir + 3) % 4;
    else if (r < 0.50) dir = (dir + 1) % 4;
    let nc = t.col + $f7b52c0eefeb7e27$var$DX[dir];
    let nr = t.row + $f7b52c0eefeb7e27$var$DY[dir];
    if (nc < 0 || nc >= m.cols || nr < 0 || nr >= m.rows) {
        const valid = [];
        for(let d = 0; d < 4; d++){
            const tc = t.col + $f7b52c0eefeb7e27$var$DX[d];
            const tr = t.row + $f7b52c0eefeb7e27$var$DY[d];
            if (tc >= 0 && tc < m.cols && tr >= 0 && tr < m.rows) valid.push(d);
        }
        if (valid.length > 0) {
            dir = valid[Math.floor(rand() * valid.length)];
            nc = t.col + $f7b52c0eefeb7e27$var$DX[dir];
            nr = t.row + $f7b52c0eefeb7e27$var$DY[dir];
        } else return {
            x1: x1,
            y1: y1,
            x2: x1,
            y2: y1
        };
    }
    t.dir = dir;
    t.col = nc;
    t.row = nr;
    return {
        x1: x1,
        y1: y1,
        x2: m.ox + t.col * m.cell + m.cell / 2,
        y2: m.oy + t.row * m.cell + m.cell / 2
    };
}
function $f7b52c0eefeb7e27$var$warmup(turtles, m, rand, steps) {
    const segments = [];
    let elapsed = 0;
    for(let i = 0; i < steps; i++){
        elapsed += $f7b52c0eefeb7e27$var$STEP_MS;
        for (const t of turtles){
            const c = $f7b52c0eefeb7e27$var$stepTurtle(t, m, rand);
            segments.push({
                ...c,
                birth: elapsed,
                phase: t.phase
            });
        }
    }
    return {
        segments: segments.filter((s)=>elapsed - s.birth < $f7b52c0eefeb7e27$var$FADE_MS),
        elapsed: elapsed
    };
}
function $f7b52c0eefeb7e27$export$3163378fc5f2d210(canvas, seed) {
    const box = canvas.parentElement;
    if (!box) return ()=>{};
    const ctx = canvas.getContext("2d");
    if (!ctx) return ()=>{};
    const colorVar = canvas.dataset.decorColor || "cyan";
    let m = $f7b52c0eefeb7e27$var$measure(box);
    let color = $f7b52c0eefeb7e27$var$readColor(document.documentElement, colorVar);
    const rand = (0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:walk`);
    let turtles = $f7b52c0eefeb7e27$var$buildTurtles((0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:init`), m, m.mobile ? 5 : 8);
    const warmupSteps = Math.ceil($f7b52c0eefeb7e27$var$FADE_MS / $f7b52c0eefeb7e27$var$STEP_MS);
    let state = $f7b52c0eefeb7e27$var$warmup(turtles, m, rand, warmupSteps);
    let segments = state.segments;
    let elapsed = state.elapsed;
    let stepAccum = 0;
    let raf = 0;
    let last = null;
    let vis = true;
    let alive = true;
    let looping = false;
    const sizeCanvas = ()=>{
        const h = Math.min(m.drawH, m.height);
        canvas.width = Math.round(m.width * m.dpr);
        canvas.height = Math.round(h * m.dpr);
        canvas.style.width = `${m.width}px`;
        canvas.style.height = `${h}px`;
        canvas.style.bottom = "auto";
        ctx.setTransform(m.dpr, 0, 0, m.dpr, 0, 0);
    };
    sizeCanvas();
    const draw = ()=>{
        const h = Math.min(m.drawH, m.height);
        ctx.clearRect(0, 0, m.width, h);
        ctx.strokeStyle = color;
        for (const s of segments){
            const alpha = Math.max(0, 1 - (elapsed - s.birth) / $f7b52c0eefeb7e27$var$FADE_MS) * 0.18;
            if (alpha <= 0) continue;
            ctx.globalAlpha = alpha;
            ctx.lineWidth = 2 + Math.sin(s.birth * 0.003 + s.phase) * 1.5;
            ctx.beginPath();
            ctx.moveTo(s.x1, s.y1);
            ctx.lineTo(s.x2, s.y2);
            ctx.stroke();
        }
        ctx.globalAlpha = 1;
    };
    draw();
    const csQ = window.matchMedia("(prefers-color-scheme: dark)");
    const moQ = window.matchMedia("(prefers-reduced-motion: reduce)");
    const tabOk = ()=>document.visibilityState !== "hidden";
    const canRun = ()=>alive && vis && tabOk() && !m.reduced;
    const halt = ()=>{
        if (looping) {
            cancelAnimationFrame(raf);
            looping = false;
            last = null;
            stepAccum = 0;
        }
    };
    const tick = (ts)=>{
        if (!canRun()) {
            looping = false;
            return;
        }
        const dt = last === null ? 16 : Math.min(ts - last, 48);
        last = ts;
        stepAccum += dt;
        while(stepAccum >= $f7b52c0eefeb7e27$var$STEP_MS){
            stepAccum -= $f7b52c0eefeb7e27$var$STEP_MS;
            elapsed += $f7b52c0eefeb7e27$var$STEP_MS;
            for (const t of turtles){
                const c = $f7b52c0eefeb7e27$var$stepTurtle(t, m, rand);
                segments.push({
                    ...c,
                    birth: elapsed,
                    phase: t.phase
                });
            }
        }
        segments = segments.filter((s)=>elapsed - s.birth < $f7b52c0eefeb7e27$var$FADE_MS);
        draw();
        raf = requestAnimationFrame(tick);
    };
    const go = ()=>{
        if (!canRun() || looping) return;
        looping = true;
        last = null;
        raf = requestAnimationFrame(tick);
    };
    const sync = ()=>{
        if (m.reduced) {
            halt();
            draw();
            return;
        }
        canRun() ? go() : halt();
    };
    const refit = ()=>{
        const next = $f7b52c0eefeb7e27$var$measure(box);
        if (next.width !== m.width || next.height !== m.height || next.dpr !== m.dpr) {
            m = next;
            const count = m.mobile ? 5 : 8;
            turtles = $f7b52c0eefeb7e27$var$buildTurtles((0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:init`), m, count);
            const refitRand = (0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:walk`);
            const w = $f7b52c0eefeb7e27$var$warmup(turtles, m, refitRand, warmupSteps);
            segments = w.segments;
            elapsed = w.elapsed;
            stepAccum = 0;
            sizeCanvas();
            draw();
        }
    };
    const recolor = ()=>{
        color = $f7b52c0eefeb7e27$var$readColor(document.documentElement, colorVar);
        draw();
    };
    const remotion = ()=>{
        m = {
            ...m,
            reduced: moQ.matches
        };
        sync();
    };
    const onVis = ()=>sync();
    const io = new IntersectionObserver((es)=>{
        vis = es.some((e)=>e.isIntersecting);
        sync();
    }, {
        threshold: 0
    });
    io.observe(box);
    const ro = new ResizeObserver(()=>{
        refit();
        sync();
    });
    ro.observe(box);
    csQ.addEventListener("change", recolor);
    moQ.addEventListener("change", remotion);
    document.addEventListener("visibilitychange", onVis);
    sync();
    return ()=>{
        alive = false;
        halt();
        io.disconnect();
        ro.disconnect();
        csQ.removeEventListener("change", recolor);
        moQ.removeEventListener("change", remotion);
        document.removeEventListener("visibilitychange", onVis);
    };
}



const $cf0a20abb8e2bf13$var$STEP = 10;
const $cf0a20abb8e2bf13$var$STEP_MS = 65;
const $cf0a20abb8e2bf13$var$FADE_MS = 3200;
const $cf0a20abb8e2bf13$var$BRANCH_P = 0.06;
const $cf0a20abb8e2bf13$var$MAX_DEPTH = 4;
const $cf0a20abb8e2bf13$var$MAX_BRANCHES = 28;
const $cf0a20abb8e2bf13$var$JITTER = 0.12;
const $cf0a20abb8e2bf13$var$DRIFT = 0.015;
function $cf0a20abb8e2bf13$var$readColor(root, v) {
    return getComputedStyle(root).getPropertyValue(`--fx-${v}`).trim();
}
function $cf0a20abb8e2bf13$var$measure(box) {
    const rect = box.getBoundingClientRect();
    const mobile = rect.width < 768;
    const dpr = Math.min(mobile ? 1.25 : 2, window.devicePixelRatio || 1);
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const w = Math.max(1, Math.round(rect.width));
    const h = Math.max(1, Math.round(rect.height));
    const title = box.querySelector(".blog-title");
    const tBot = title ? title.getBoundingClientRect().bottom - rect.top : mobile ? 100 : 130;
    const zoneTop = Math.max(10, tBot - 120);
    const zoneBot = tBot + (mobile ? 240 : 360);
    return {
        width: w,
        height: h,
        dpr: dpr,
        mobile: mobile,
        reduced: reduced,
        zoneTop: zoneTop,
        zoneBot: zoneBot,
        drawH: Math.min(zoneBot + 30, h)
    };
}
function $cf0a20abb8e2bf13$var$resetRoot(g, rand, m) {
    g.x = rand() * m.width;
    g.y = m.zoneTop + rand() * (m.zoneBot - m.zoneTop) * 0.25;
    g.angle = Math.PI / 2 + (rand() - 0.5) * Math.PI * 0.7;
    g.depth = 0;
    g.phase = rand() * Math.PI * 2;
    g.alive = true;
}
function $cf0a20abb8e2bf13$var$buildRoots(rand, m, n) {
    return Array.from({
        length: n
    }, ()=>{
        const g = {};
        $cf0a20abb8e2bf13$var$resetRoot(g, rand, m);
        return g;
    });
}
function $cf0a20abb8e2bf13$var$stepGrower(g, branches, m, rand) {
    if (!g.alive) return null;
    const x1 = g.x;
    const y1 = g.y;
    g.angle += (rand() - 0.5) * 2 * $cf0a20abb8e2bf13$var$JITTER;
    g.angle += (Math.PI / 2 - g.angle) * $cf0a20abb8e2bf13$var$DRIFT;
    g.x += Math.cos(g.angle) * $cf0a20abb8e2bf13$var$STEP;
    g.y += Math.sin(g.angle) * $cf0a20abb8e2bf13$var$STEP;
    if (g.x < -5 || g.x > m.width + 5 || g.y < m.zoneTop - 30 || g.y > m.zoneBot + 30) {
        g.alive = false;
        return null;
    }
    if (rand() < $cf0a20abb8e2bf13$var$BRANCH_P && g.depth < $cf0a20abb8e2bf13$var$MAX_DEPTH && branches.length < $cf0a20abb8e2bf13$var$MAX_BRANCHES) {
        const sign = rand() < 0.5 ? 1 : -1;
        const spread = 0.35 + rand() * 0.4;
        branches.push({
            x: g.x,
            y: g.y,
            angle: g.angle + sign * spread,
            depth: g.depth + 1,
            phase: rand() * Math.PI * 2,
            alive: true
        });
    }
    if (rand() < 0.003 + g.depth * 0.012) g.alive = false;
    return {
        x1: x1,
        y1: y1,
        x2: g.x,
        y2: g.y,
        birth: 0,
        depth: g.depth,
        phase: g.phase
    };
}
function $cf0a20abb8e2bf13$var$simulate(roots, branches, m, rand, steps) {
    const segments = [];
    let elapsed = 0;
    for(let i = 0; i < steps; i++){
        elapsed += $cf0a20abb8e2bf13$var$STEP_MS;
        for (const r of roots){
            if (!r.alive) {
                $cf0a20abb8e2bf13$var$resetRoot(r, rand, m);
                continue;
            }
            const seg = $cf0a20abb8e2bf13$var$stepGrower(r, branches, m, rand);
            if (seg) {
                seg.birth = elapsed;
                segments.push(seg);
            }
        }
        const bLen = branches.length;
        for(let j = 0; j < bLen; j++){
            if (!branches[j].alive) continue;
            const seg = $cf0a20abb8e2bf13$var$stepGrower(branches[j], branches, m, rand);
            if (seg) {
                seg.birth = elapsed;
                segments.push(seg);
            }
        }
        for(let j = branches.length - 1; j >= 0; j--)if (!branches[j].alive) branches.splice(j, 1);
    }
    return {
        segments: segments.filter((s)=>elapsed - s.birth < $cf0a20abb8e2bf13$var$FADE_MS),
        elapsed: elapsed
    };
}
function $cf0a20abb8e2bf13$export$493be91499c5a22(canvas, seed) {
    const box = canvas.parentElement;
    if (!box) return ()=>{};
    const ctx = canvas.getContext("2d");
    if (!ctx) return ()=>{};
    const colorVar = canvas.dataset.decorColor || "cyan";
    let m = $cf0a20abb8e2bf13$var$measure(box);
    let color = $cf0a20abb8e2bf13$var$readColor(document.documentElement, colorVar);
    const rand = (0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:grow`);
    const rootCount = m.mobile ? 4 : 6;
    let roots = $cf0a20abb8e2bf13$var$buildRoots((0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:init`), m, rootCount);
    let branches = [];
    const warmupSteps = Math.ceil($cf0a20abb8e2bf13$var$FADE_MS / $cf0a20abb8e2bf13$var$STEP_MS);
    let state = $cf0a20abb8e2bf13$var$simulate(roots, branches, m, rand, warmupSteps);
    let segments = state.segments;
    let elapsed = state.elapsed;
    let stepAccum = 0;
    let raf = 0;
    let last = null;
    let vis = true;
    let alive = true;
    let looping = false;
    const sizeCanvas = ()=>{
        const h = Math.min(m.drawH, m.height);
        canvas.width = Math.round(m.width * m.dpr);
        canvas.height = Math.round(h * m.dpr);
        canvas.style.width = `${m.width}px`;
        canvas.style.height = `${h}px`;
        canvas.style.bottom = "auto";
        ctx.setTransform(m.dpr, 0, 0, m.dpr, 0, 0);
    };
    sizeCanvas();
    const draw = ()=>{
        const h = Math.min(m.drawH, m.height);
        ctx.clearRect(0, 0, m.width, h);
        ctx.strokeStyle = color;
        ctx.lineCap = "round";
        const fadeStart = (m.zoneTop + m.zoneBot) * 0.5;
        const fadeRange = m.zoneBot - fadeStart;
        for (const s of segments){
            const age = (elapsed - s.birth) / $cf0a20abb8e2bf13$var$FADE_MS;
            const midY = (s.y1 + s.y2) * 0.5;
            const vFade = midY > fadeStart ? Math.max(0, 1 - (midY - fadeStart) / fadeRange) : 1;
            const alpha = Math.max(0, 1 - age) * (0.2 - s.depth * 0.025) * vFade;
            if (alpha <= 0) continue;
            ctx.globalAlpha = alpha;
            ctx.lineWidth = 2.5 - s.depth * 0.35 + Math.sin(s.birth * 0.002 + s.phase) * 0.4;
            ctx.beginPath();
            ctx.moveTo(s.x1, s.y1);
            ctx.lineTo(s.x2, s.y2);
            ctx.stroke();
        }
        ctx.globalAlpha = 1;
    };
    draw();
    const csQ = window.matchMedia("(prefers-color-scheme: dark)");
    const moQ = window.matchMedia("(prefers-reduced-motion: reduce)");
    const tabOk = ()=>document.visibilityState !== "hidden";
    const canRun = ()=>alive && vis && tabOk() && !m.reduced;
    const halt = ()=>{
        if (looping) {
            cancelAnimationFrame(raf);
            looping = false;
            last = null;
            stepAccum = 0;
        }
    };
    const tick = (ts)=>{
        if (!canRun()) {
            looping = false;
            return;
        }
        const dt = last === null ? 16 : Math.min(ts - last, 48);
        last = ts;
        stepAccum += dt;
        while(stepAccum >= $cf0a20abb8e2bf13$var$STEP_MS){
            stepAccum -= $cf0a20abb8e2bf13$var$STEP_MS;
            elapsed += $cf0a20abb8e2bf13$var$STEP_MS;
            for (const r of roots){
                if (!r.alive) {
                    $cf0a20abb8e2bf13$var$resetRoot(r, rand, m);
                    continue;
                }
                const seg = $cf0a20abb8e2bf13$var$stepGrower(r, branches, m, rand);
                if (seg) {
                    seg.birth = elapsed;
                    segments.push(seg);
                }
            }
            const bLen = branches.length;
            for(let j = 0; j < bLen; j++){
                if (!branches[j].alive) continue;
                const seg = $cf0a20abb8e2bf13$var$stepGrower(branches[j], branches, m, rand);
                if (seg) {
                    seg.birth = elapsed;
                    segments.push(seg);
                }
            }
            for(let j = branches.length - 1; j >= 0; j--)if (!branches[j].alive) branches.splice(j, 1);
        }
        segments = segments.filter((s)=>elapsed - s.birth < $cf0a20abb8e2bf13$var$FADE_MS);
        draw();
        raf = requestAnimationFrame(tick);
    };
    const go = ()=>{
        if (!canRun() || looping) return;
        looping = true;
        last = null;
        raf = requestAnimationFrame(tick);
    };
    const sync = ()=>{
        if (m.reduced) {
            halt();
            draw();
            return;
        }
        canRun() ? go() : halt();
    };
    const refit = ()=>{
        const next = $cf0a20abb8e2bf13$var$measure(box);
        if (next.width !== m.width || next.height !== m.height || next.dpr !== m.dpr) {
            m = next;
            const n = m.mobile ? 4 : 6;
            roots = $cf0a20abb8e2bf13$var$buildRoots((0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:init`), m, n);
            branches = [];
            const refitRand = (0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:grow`);
            const w = $cf0a20abb8e2bf13$var$simulate(roots, branches, m, refitRand, warmupSteps);
            segments = w.segments;
            elapsed = w.elapsed;
            stepAccum = 0;
            sizeCanvas();
            draw();
        }
    };
    const recolor = ()=>{
        color = $cf0a20abb8e2bf13$var$readColor(document.documentElement, colorVar);
        draw();
    };
    const remotion = ()=>{
        m = {
            ...m,
            reduced: moQ.matches
        };
        sync();
    };
    const onVis = ()=>sync();
    const io = new IntersectionObserver((es)=>{
        vis = es.some((e)=>e.isIntersecting);
        sync();
    }, {
        threshold: 0
    });
    io.observe(box);
    const ro = new ResizeObserver(()=>{
        refit();
        sync();
    });
    ro.observe(box);
    csQ.addEventListener("change", recolor);
    moQ.addEventListener("change", remotion);
    document.addEventListener("visibilitychange", onVis);
    sync();
    return ()=>{
        alive = false;
        halt();
        io.disconnect();
        ro.disconnect();
        csQ.removeEventListener("change", recolor);
        moQ.removeEventListener("change", remotion);
        document.removeEventListener("visibilitychange", onVis);
    };
}



const $14e30f4df45f45c1$var$STEP_MS = 16;
const $14e30f4df45f45c1$var$SPEED = 0.55;
const $14e30f4df45f45c1$var$MAX_FORCE = 0.03;
const $14e30f4df45f45c1$var$NEIGHBOUR = 70;
const $14e30f4df45f45c1$var$SEPARATION = 26;
const $14e30f4df45f45c1$var$LEAD_PULL = 0.0022;
const $14e30f4df45f45c1$var$TRAIL = 8;
const $14e30f4df45f45c1$var$TRAIL_MS = 80;
const $14e30f4df45f45c1$var$WANDER = 0.00022;
const $14e30f4df45f45c1$var$GROUPS = 3;
function $14e30f4df45f45c1$var$readColor(root, v) {
    return getComputedStyle(root).getPropertyValue(`--fx-${v}`).trim();
}
function $14e30f4df45f45c1$var$measure(box) {
    const rect = box.getBoundingClientRect();
    const mobile = rect.width < 768;
    const dpr = Math.min(mobile ? 1.25 : 2, window.devicePixelRatio || 1);
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const w = Math.max(1, Math.round(rect.width));
    const h = Math.max(1, Math.round(rect.height));
    const title = box.querySelector(".blog-title");
    const tBot = title ? title.getBoundingClientRect().bottom - rect.top : mobile ? 100 : 130;
    const zoneTop = Math.max(6, tBot - 150);
    // On mobile there are no side margins, so the swarms stay above the text.
    const zoneBot = tBot + (mobile ? 90 : 300);
    return {
        width: w,
        height: h,
        dpr: dpr,
        mobile: mobile,
        reduced: reduced,
        zoneTop: zoneTop,
        zoneBot: zoneBot,
        drawH: Math.min(zoneBot + 30, h)
    };
}
/** Slow drifting target each swarm's leader chases, spread across the band. */ function $14e30f4df45f45c1$var$leadTarget(g, phase, t, m) {
    const lane = (g + 0.5) / $14e30f4df45f45c1$var$GROUPS;
    const midY = (m.zoneTop + m.zoneBot) * 0.5;
    const spanY = (m.zoneBot - m.zoneTop) * 0.34;
    const x = m.width * lane + Math.sin(t * $14e30f4df45f45c1$var$WANDER + phase) * m.width * 0.2;
    const y = midY + Math.sin(t * $14e30f4df45f45c1$var$WANDER * 1.7 + phase * 2) * spanY;
    return [
        x,
        y
    ];
}
function $14e30f4df45f45c1$var$buildFlock(rand, m, n) {
    const perGroup = Math.ceil(n / $14e30f4df45f45c1$var$GROUPS);
    return Array.from({
        length: n
    }, (_, i)=>{
        const group = Math.floor(i / perGroup);
        const lane = (group + 0.5) / $14e30f4df45f45c1$var$GROUPS;
        const angle = rand() * Math.PI * 2;
        return {
            x: m.width * lane + (rand() - 0.5) * m.width * 0.22,
            y: m.zoneTop + (0.25 + rand() * 0.5) * (m.zoneBot - m.zoneTop),
            vx: Math.cos(angle) * $14e30f4df45f45c1$var$SPEED,
            vy: Math.sin(angle) * $14e30f4df45f45c1$var$SPEED * 0.5,
            group: group,
            // One supervisor per swarm; the rest steer toward it.
            lead: i % perGroup === 0,
            phase: rand() * Math.PI * 2,
            trail: []
        };
    });
}
function $14e30f4df45f45c1$var$limit(x, y, max) {
    const len = Math.hypot(x, y);
    if (len <= max || len === 0) return [
        x,
        y
    ];
    return [
        x / len * max,
        y / len * max
    ];
}
function $14e30f4df45f45c1$var$stepFlock(flock, m, t) {
    const leads = flock.filter((b)=>b.lead);
    for (const b of flock){
        let ax = 0;
        let ay = 0;
        if (b.lead) {
            const [tx, ty] = $14e30f4df45f45c1$var$leadTarget(b.group, b.phase, t, m);
            ax += (tx - b.x) * 0.0009;
            ay += (ty - b.y) * 0.0014;
        } else {
            let sepX = 0, sepY = 0;
            let aliX = 0, aliY = 0;
            let cohX = 0, cohY = 0;
            let n = 0;
            for (const o of flock){
                if (o === b) continue;
                const dx = o.x - b.x;
                const dy = o.y - b.y;
                const d2 = dx * dx + dy * dy;
                if (d2 === 0) continue;
                if (d2 < $14e30f4df45f45c1$var$SEPARATION * $14e30f4df45f45c1$var$SEPARATION) {
                    sepX -= dx / d2;
                    sepY -= dy / d2;
                }
                if (o.group !== b.group || d2 > $14e30f4df45f45c1$var$NEIGHBOUR * $14e30f4df45f45c1$var$NEIGHBOUR) continue;
                n++;
                aliX += o.vx;
                aliY += o.vy;
                cohX += o.x;
                cohY += o.y;
            }
            ax += sepX * 6;
            ay += sepY * 6;
            if (n > 0) {
                ax += (aliX / n - b.vx) * 0.03 + (cohX / n - b.x) * 0.0004;
                ay += (aliY / n - b.vy) * 0.03 + (cohY / n - b.y) * 0.0004;
            }
            const lead = leads.find((l)=>l.group === b.group);
            if (lead) {
                ax += (lead.x - b.x) * $14e30f4df45f45c1$var$LEAD_PULL;
                ay += (lead.y - b.y) * $14e30f4df45f45c1$var$LEAD_PULL;
            }
        }
        // Soft walls keep the flock inside the header band.
        if (b.y < m.zoneTop + 20) ay += (m.zoneTop + 20 - b.y) * 0.005;
        if (b.y > m.zoneBot - 20) ay -= (b.y - (m.zoneBot - 20)) * 0.005;
        [ax, ay] = $14e30f4df45f45c1$var$limit(ax, ay, $14e30f4df45f45c1$var$MAX_FORCE);
        b.vx += ax;
        b.vy += ay;
        const target = b.lead ? $14e30f4df45f45c1$var$SPEED * 0.9 : $14e30f4df45f45c1$var$SPEED;
        const sp = Math.hypot(b.vx, b.vy) || 1;
        b.vx = b.vx / sp * target;
        b.vy = b.vy / sp * target;
        b.x += b.vx;
        b.y += b.vy;
        if (b.x < -20) b.x += m.width + 40;
        if (b.x > m.width + 20) b.x -= m.width + 40;
    }
}
function $14e30f4df45f45c1$var$pushTrail(flock) {
    for (const b of flock){
        b.trail.unshift(b.x, b.y);
        if (b.trail.length > $14e30f4df45f45c1$var$TRAIL * 2) b.trail.length = $14e30f4df45f45c1$var$TRAIL * 2;
    }
}
function $14e30f4df45f45c1$export$446dc5c686b0e893(canvas, seed) {
    const box = canvas.parentElement;
    if (!box) return ()=>{};
    const ctx = canvas.getContext("2d");
    if (!ctx) return ()=>{};
    const colorVar = canvas.dataset.decorColor || "cyan";
    let m = $14e30f4df45f45c1$var$measure(box);
    let color = $14e30f4df45f45c1$var$readColor(document.documentElement, colorVar);
    let flock = $14e30f4df45f45c1$var$buildFlock((0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:flock`), m, m.mobile ? 36 : 60);
    let t = 0;
    let raf = 0;
    let last = null;
    let stepAccum = 0;
    let trailAccum = 0;
    let vis = true;
    let alive = true;
    let looping = false;
    const trailEvery = Math.round($14e30f4df45f45c1$var$TRAIL_MS / $14e30f4df45f45c1$var$STEP_MS);
    const warm = (steps)=>{
        for(let i = 0; i < steps; i++){
            t += $14e30f4df45f45c1$var$STEP_MS;
            $14e30f4df45f45c1$var$stepFlock(flock, m, t);
            if (i % trailEvery === 0) $14e30f4df45f45c1$var$pushTrail(flock);
        }
    };
    warm(320);
    const sizeCanvas = ()=>{
        const h = Math.min(m.drawH, m.height);
        canvas.width = Math.round(m.width * m.dpr);
        canvas.height = Math.round(h * m.dpr);
        canvas.style.width = `${m.width}px`;
        canvas.style.height = `${h}px`;
        canvas.style.bottom = "auto";
        ctx.setTransform(m.dpr, 0, 0, m.dpr, 0, 0);
    };
    sizeCanvas();
    const draw = ()=>{
        const h = Math.min(m.drawH, m.height);
        ctx.clearRect(0, 0, m.width, h);
        ctx.strokeStyle = color;
        ctx.fillStyle = color;
        ctx.lineCap = "round";
        ctx.lineJoin = "round";
        const fadeStart = m.zoneTop + (m.zoneBot - m.zoneTop) * 0.62;
        const fadeRange = m.zoneBot - fadeStart;
        for (const b of flock){
            const vFade = b.y > fadeStart ? Math.max(0, 1 - (b.y - fadeStart) / fadeRange) : 1;
            const topFade = b.y < m.zoneTop + 50 ? Math.max(0, (b.y - m.zoneTop) / 50) : 1;
            const base = (b.lead ? 0.55 : 0.34) * vFade * topFade;
            if (base <= 0.01) continue;
            ctx.lineWidth = b.lead ? 1.4 : 1;
            for(let i = 2; i < b.trail.length - 1; i += 2){
                const x1 = b.trail[i - 2];
                const y1 = b.trail[i - 1];
                const x2 = b.trail[i];
                const y2 = b.trail[i + 1];
                if (Math.abs(x2 - x1) > m.width * 0.5) continue;
                ctx.globalAlpha = base * (1 - i / b.trail.length) * 0.55;
                ctx.beginPath();
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.stroke();
            }
            // Body — a small arrowhead pointing along the velocity.
            const a = Math.atan2(b.vy, b.vx);
            const size = b.lead ? 6 : 4;
            ctx.globalAlpha = base;
            ctx.beginPath();
            ctx.moveTo(b.x + Math.cos(a) * size, b.y + Math.sin(a) * size);
            ctx.lineTo(b.x + Math.cos(a + 2.5) * size * 0.8, b.y + Math.sin(a + 2.5) * size * 0.8);
            ctx.lineTo(b.x + Math.cos(a - 2.5) * size * 0.8, b.y + Math.sin(a - 2.5) * size * 0.8);
            ctx.closePath();
            ctx.fill();
        }
        ctx.globalAlpha = 1;
    };
    draw();
    const csQ = window.matchMedia("(prefers-color-scheme: dark)");
    const moQ = window.matchMedia("(prefers-reduced-motion: reduce)");
    const tabOk = ()=>document.visibilityState !== "hidden";
    const canRun = ()=>alive && vis && tabOk() && !m.reduced;
    const halt = ()=>{
        if (looping) {
            cancelAnimationFrame(raf);
            looping = false;
            last = null;
            stepAccum = 0;
        }
    };
    const tick = (ts)=>{
        if (!canRun()) {
            looping = false;
            return;
        }
        const dt = last === null ? 16 : Math.min(ts - last, 48);
        last = ts;
        stepAccum += dt;
        trailAccum += dt;
        while(stepAccum >= $14e30f4df45f45c1$var$STEP_MS){
            stepAccum -= $14e30f4df45f45c1$var$STEP_MS;
            t += $14e30f4df45f45c1$var$STEP_MS;
            $14e30f4df45f45c1$var$stepFlock(flock, m, t);
        }
        while(trailAccum >= $14e30f4df45f45c1$var$TRAIL_MS){
            trailAccum -= $14e30f4df45f45c1$var$TRAIL_MS;
            $14e30f4df45f45c1$var$pushTrail(flock);
        }
        draw();
        raf = requestAnimationFrame(tick);
    };
    const go = ()=>{
        if (!canRun() || looping) return;
        looping = true;
        last = null;
        raf = requestAnimationFrame(tick);
    };
    const sync = ()=>{
        if (m.reduced) {
            halt();
            draw();
            return;
        }
        canRun() ? go() : halt();
    };
    const refit = ()=>{
        const next = $14e30f4df45f45c1$var$measure(box);
        if (next.width !== m.width || next.height !== m.height || next.dpr !== m.dpr) {
            m = next;
            flock = $14e30f4df45f45c1$var$buildFlock((0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:flock`), m, m.mobile ? 36 : 60);
            t = 0;
            stepAccum = 0;
            trailAccum = 0;
            warm(320);
            sizeCanvas();
            draw();
        }
    };
    const recolor = ()=>{
        color = $14e30f4df45f45c1$var$readColor(document.documentElement, colorVar);
        draw();
    };
    const remotion = ()=>{
        m = {
            ...m,
            reduced: moQ.matches
        };
        sync();
    };
    const onVis = ()=>sync();
    const io = new IntersectionObserver((es)=>{
        vis = es.some((e)=>e.isIntersecting);
        sync();
    }, {
        threshold: 0
    });
    io.observe(box);
    const ro = new ResizeObserver(()=>{
        refit();
        sync();
    });
    ro.observe(box);
    csQ.addEventListener("change", recolor);
    moQ.addEventListener("change", remotion);
    document.addEventListener("visibilitychange", onVis);
    sync();
    return ()=>{
        alive = false;
        halt();
        io.disconnect();
        ro.disconnect();
        csQ.removeEventListener("change", recolor);
        moQ.removeEventListener("change", remotion);
        document.removeEventListener("visibilitychange", onVis);
    };
}



const $eaebf3fc7fc4df72$var$DEL_MS = 1500;
const $eaebf3fc7fc4df72$var$ADD_MS = 900;
const $eaebf3fc7fc4df72$var$SETTLE_MS = 3200;
const $eaebf3fc7fc4df72$var$HUNK_MS = $eaebf3fc7fc4df72$var$DEL_MS + $eaebf3fc7fc4df72$var$ADD_MS + $eaebf3fc7fc4df72$var$SETTLE_MS;
const $eaebf3fc7fc4df72$var$FRAME_MS = 1000 / 30;
const $eaebf3fc7fc4df72$var$FADE_PX = 90;
const $eaebf3fc7fc4df72$var$NEUTRAL_ALPHA = 0.2;
function $eaebf3fc7fc4df72$var$hash(a, b, c) {
    let h = Math.imul(a ^ 0x9e3779b9, 0x85ebca6b) ^ Math.imul(b + 0x632be5ab, 0xc2b2ae35) ^ Math.imul(c + 0x27d4eb2f, 0x165667b1);
    h ^= h >>> 15;
    h = Math.imul(h, 0x2c1b3c6d);
    h ^= h >>> 12;
    h = Math.imul(h, 0x297a2d39);
    h ^= h >>> 15;
    return (h >>> 0) / 4294967296;
}
// Token widths for one line of fake code, starting with the line's indent.
function $eaebf3fc7fc4df72$var$lineTokens(base, lane, row, version, maxW) {
    const r = (k)=>$eaebf3fc7fc4df72$var$hash(base + version * 7919, lane * 131 + k, row);
    if (r(0) < 0.12) return [];
    const indent = Math.max(0, Math.round(1.6 + 1.5 * Math.sin(row * 0.23 + lane * 1.7) + (r(1) - 0.5) * 1.4));
    const out = [
        indent * 9
    ];
    let x = indent * 9;
    const n = 1 + Math.floor(r(2) * 5);
    for(let i = 0; i < n; i++){
        const w = 6 + Math.floor(r(3 + i) * (i === 0 ? 34 : 46));
        if (x + w > maxW) break;
        out.push(w);
        x += w + 4;
    }
    return out;
}
function $eaebf3fc7fc4df72$var$readPalette() {
    const cs = getComputedStyle(document.documentElement);
    const get = (v)=>cs.getPropertyValue(`--fx-${v}`).trim();
    return {
        tx: get("tx3"),
        red: get("red"),
        green: get("green")
    };
}
function $eaebf3fc7fc4df72$var$measure(box) {
    const rect = box.getBoundingClientRect();
    const width = Math.max(1, Math.round(rect.width));
    const mobile = width < 768;
    const content = box.querySelector(".blog-content");
    const height = content ? Math.round(content.getBoundingClientRect().top - rect.top) : 320;
    const laneW = mobile ? 150 : 210;
    const lanes = [];
    for(let x = mobile ? 10 : 18; x < width; x += laneW + (mobile ? 18 : 30))lanes.push(x);
    return {
        width: width,
        height: Math.max(1, height),
        dpr: Math.min(mobile ? 1.5 : 2, window.devicePixelRatio || 1),
        reduced: window.matchMedia("(prefers-reduced-motion: reduce)").matches,
        pitch: mobile ? 9 : 11,
        block: mobile ? 3 : 4,
        laneW: laneW,
        lanes: lanes
    };
}
function $eaebf3fc7fc4df72$export$fe02fae058c7ace(canvas, seed) {
    const box = canvas.parentElement;
    const ctx = canvas.getContext("2d");
    if (!box || !ctx) return ()=>{};
    const base = Math.floor((0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:diff`)() * 2 ** 31);
    const rand = (0, $7e612384a04d987e$export$7f4f77f59a323cea)(`${seed}:hunks`);
    const versions = new Map();
    let hunks = [];
    let m = $eaebf3fc7fc4df72$var$measure(box);
    let pal = $eaebf3fc7fc4df72$var$readPalette();
    let now = 0;
    let raf = 0;
    let lastFrame = 0;
    let visible = true;
    const size = ()=>{
        canvas.width = Math.round(m.width * m.dpr);
        canvas.height = Math.round(m.height * m.dpr);
        canvas.style.width = `${m.width}px`;
        canvas.style.height = `${m.height}px`;
        canvas.style.bottom = "auto";
    };
    size();
    const rows = ()=>Math.ceil(m.height / m.pitch);
    const spawn = ()=>{
        const lane = Math.floor(rand() * m.lanes.length);
        const len = 1 + Math.floor(rand() * 4);
        const row = Math.floor(rand() * Math.max(1, rows() - len - 4));
        if (hunks.some((h)=>h.lane === lane && row < h.row + h.len + 2 && h.row < row + len + 2)) return;
        hunks.push({
            lane: lane,
            row: row,
            len: len,
            t0: now
        });
    };
    const hunkAt = (lane, row)=>hunks.find((h)=>h.lane === lane && row >= h.row && row < h.row + h.len);
    const draw = ()=>{
        ctx.setTransform(m.dpr, 0, 0, m.dpr, 0, 0);
        ctx.clearRect(0, 0, m.width, m.height);
        const last = rows();
        for(let li = 0; li < m.lanes.length; li++){
            const lx = m.lanes[li];
            for(let row = 0; row <= last; row++){
                const y = row * m.pitch;
                const version = versions.get(`${li}:${row}`) ?? 0;
                const h = hunkAt(li, row);
                let tokens = $eaebf3fc7fc4df72$var$lineTokens(base, li, row, version, m.laneW);
                let color = pal.tx;
                let alpha = $eaebf3fc7fc4df72$var$NEUTRAL_ALPHA;
                let reveal = 1;
                let band = null;
                let bandA = 0;
                if (h) {
                    const t = now - h.t0;
                    const stagger = (row - h.row) * 90;
                    if (t < $eaebf3fc7fc4df72$var$DEL_MS) {
                        const k = Math.min(1, Math.max(0, (t - stagger) / 420));
                        color = pal.red;
                        alpha = $eaebf3fc7fc4df72$var$NEUTRAL_ALPHA + (0.62 - $eaebf3fc7fc4df72$var$NEUTRAL_ALPHA) * k;
                        reveal = 1 - Math.min(1, Math.max(0, (t - 600 - stagger) / 600));
                        band = pal.red;
                        bandA = 0.1 * k;
                    } else {
                        tokens = $eaebf3fc7fc4df72$var$lineTokens(base, li, row, version + 1, m.laneW);
                        const ta = t - $eaebf3fc7fc4df72$var$DEL_MS;
                        reveal = Math.min(1, Math.max(0, (ta - stagger) / ($eaebf3fc7fc4df72$var$ADD_MS - 300)));
                        const settle = Math.min(1, Math.max(0, (ta - $eaebf3fc7fc4df72$var$ADD_MS) / $eaebf3fc7fc4df72$var$SETTLE_MS));
                        color = settle < 1 ? pal.green : pal.tx;
                        alpha = 0.66 - (0.66 - $eaebf3fc7fc4df72$var$NEUTRAL_ALPHA) * settle;
                        band = pal.green;
                        bandA = 0.1 * (1 - settle);
                    }
                }
                if (band && bandA > 0) {
                    ctx.globalAlpha = bandA;
                    ctx.fillStyle = band;
                    ctx.fillRect(lx - 6, y - 2, m.laneW + 8, m.pitch);
                    ctx.globalAlpha = Math.min(1, bandA * 6);
                    ctx.fillRect(lx - 6, y - 2, 2, m.pitch);
                }
                if (tokens.length < 2) continue;
                ctx.globalAlpha = alpha;
                ctx.fillStyle = color;
                let x = lx + tokens[0];
                const total = tokens.slice(1).reduce((s, w)=>s + w + 4, 0);
                let budget = total * reveal;
                for(let i = 1; i < tokens.length && budget > 0; i++){
                    ctx.fillRect(x, y, Math.min(tokens[i], budget), m.block);
                    budget -= tokens[i] + 4;
                    x += tokens[i] + 4;
                }
            }
        }
        // Fade the field out above the first paragraph.
        ctx.globalCompositeOperation = "destination-out";
        ctx.globalAlpha = 1;
        const g = ctx.createLinearGradient(0, m.height - $eaebf3fc7fc4df72$var$FADE_PX, 0, m.height);
        g.addColorStop(0, "rgba(0,0,0,0)");
        g.addColorStop(1, "rgba(0,0,0,1)");
        ctx.fillStyle = g;
        ctx.fillRect(0, m.height - $eaebf3fc7fc4df72$var$FADE_PX, m.width, $eaebf3fc7fc4df72$var$FADE_PX);
        ctx.globalCompositeOperation = "source-over";
    };
    const step = ()=>{
        for (const h of hunks){
            if (now - h.t0 < $eaebf3fc7fc4df72$var$HUNK_MS) continue;
            for(let r = h.row; r < h.row + h.len; r++){
                const key = `${h.lane}:${r}`;
                versions.set(key, (versions.get(key) ?? 0) + 1);
            }
        }
        hunks = hunks.filter((h)=>now - h.t0 < $eaebf3fc7fc4df72$var$HUNK_MS);
        const target = Math.max(2, Math.round(m.lanes.length * 1.2));
        if (hunks.length < target && rand() < 0.08) spawn();
    };
    // Start mid-edit so the first paint, and the reduced-motion still, already
    // show hunks at different stages.
    for(let i = 0; i < 400; i++){
        now += 50;
        step();
    }
    draw();
    const tick = (ts)=>{
        raf = requestAnimationFrame(tick);
        if (ts - lastFrame < $eaebf3fc7fc4df72$var$FRAME_MS) return;
        now += lastFrame === 0 ? $eaebf3fc7fc4df72$var$FRAME_MS : Math.min(ts - lastFrame, 100);
        lastFrame = ts;
        step();
        draw();
    };
    const start = ()=>{
        if (raf || m.reduced || !visible || document.visibilityState === "hidden") return;
        lastFrame = 0;
        raf = requestAnimationFrame(tick);
    };
    const stop = ()=>{
        cancelAnimationFrame(raf);
        raf = 0;
    };
    const refit = ()=>{
        const next = $eaebf3fc7fc4df72$var$measure(box);
        if (next.width === m.width && next.height === m.height && next.dpr === m.dpr) return;
        m = next;
        size();
        draw();
    };
    const onVis = ()=>document.visibilityState === "hidden" ? stop() : start();
    const csQ = window.matchMedia("(prefers-color-scheme: dark)");
    const moQ = window.matchMedia("(prefers-reduced-motion: reduce)");
    const recolor = ()=>{
        pal = $eaebf3fc7fc4df72$var$readPalette();
        draw();
    };
    const remotion = ()=>{
        m = {
            ...m,
            reduced: moQ.matches
        };
        if (m.reduced) stop();
        else start();
    };
    const io = new IntersectionObserver((es)=>{
        visible = es.some((e)=>e.isIntersecting);
        if (visible) start();
        else stop();
    });
    io.observe(canvas);
    window.addEventListener("resize", refit);
    document.addEventListener("visibilitychange", onVis);
    csQ.addEventListener("change", recolor);
    moQ.addEventListener("change", remotion);
    document.fonts?.ready.then(refit).catch(()=>{});
    start();
    return ()=>{
        stop();
        io.disconnect();
        window.removeEventListener("resize", refit);
        document.removeEventListener("visibilitychange", onVis);
        csQ.removeEventListener("change", recolor);
        moQ.removeEventListener("change", remotion);
    };
}


const $ae77d0de3dbcf2d4$var$canvasRenderers = {
    "local-inference": (0, $f7b52c0eefeb7e27$export$3163378fc5f2d210),
    "asking": (0, $cf0a20abb8e2bf13$export$493be91499c5a22),
    "boids": (0, $14e30f4df45f45c1$export$446dc5c686b0e893),
    "diff": (0, $eaebf3fc7fc4df72$export$fe02fae058c7ace)
};
function $ae77d0de3dbcf2d4$var$initCanvasDecor(canvas) {
    const kind = canvas.dataset.decorCanvas;
    const seed = canvas.dataset.decorSeed ?? "blog-canvas";
    if (!kind) return;
    const init = $ae77d0de3dbcf2d4$var$canvasRenderers[kind];
    if (init) {
        init(canvas, seed);
        return;
    }
    console.warn(`[blog-decor] Unknown canvas kind "${kind}". Supported kinds: ${(0, $5b8e7fae80eb3a8a$export$e45e8ebdaeaf03e9).join(", ")}.`);
}
function $ae77d0de3dbcf2d4$var$boot() {
    document.querySelectorAll(".blog-decor-canvas").forEach((canvas)=>{
        $ae77d0de3dbcf2d4$var$initCanvasDecor(canvas);
    });
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $ae77d0de3dbcf2d4$var$boot, {
    once: true
});
else $ae77d0de3dbcf2d4$var$boot();


//# sourceMappingURL=index.6fc069f8.js.map
